import { z } from "zod";

export const EMAIL_INGEST_CANDIDATE_VERSION = 1;

const emailIngestProviderSchema = z.enum(["gmail", "microsoft-graph"]);
export const emailIngestMailboxSchema = z.object({
  provider: emailIngestProviderSchema,
  configId: z.uuid(),
  mailboxAddress: z.string().trim().toLowerCase().pipe(z.email()),
});
export type EmailIngestMailbox = z.infer<typeof emailIngestMailboxSchema>;
export const emailIngestShadowResultSchema = z.object({
  version: z.number().int().positive(),
  outcome: z.enum([
    "match",
    "mismatch",
    "error",
    "missing_legacy",
    "duplicate",
    "source_deleted",
  ]),
  differences: z.array(z.string()),
});
export type EmailIngestShadowResult = z.infer<
  typeof emailIngestShadowResultSchema
>;
